import { formatFloatTwoDecimals } from "@shared/utils/formatters/formatNumber"
import { createRequest, platform } from "@shared/platform-api/requests"
import { createRequestHook } from "../../../../api/createRequestHook"

export type Output = number | null

export type Input = Readonly<{
  brokerId?: string
}>

export const brokerConnectivity = createRequest<Input, Output>(async (input, getToken) => {
  if (!input.brokerId) {
    return null
  }

  const broker = await platform(getToken).brokers.findBroker({ id: input.brokerId })

  return formatFloatTwoDecimals(broker.connectivityRatio ?? 0)
})

export const useBrokerConnectivity = createRequestHook(brokerConnectivity)
